// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"48":"0f527164","563":"60cbc548"}[chunkId] + ".chunk.js";
};